import React, { Component } from 'react';
import Raven from 'raven-js';
import { connect } from 'react-redux';

import Error404 from '../../screens/404';

type Props = {
  reduxState: Object,
  children: React.Node,
  errorInAppLevel: boolean,
};

type State = {
  error: string,
  errorInfo: Object | null,
};

const mapStateToProps = state => ({ reduxState: state });
class ErrorBoundary extends Component<Props, State> {
  static defaultProps = {
    errorInAppLevel: false,
  };

  state = { error: null, errorInfo: null };

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });

    Raven.captureException(error, {
      extra: { errorInfo, state: this.props.reduxState },
    });
  }

  render() {
    const { errorInAppLevel, children } = this.props;

    if (!this.state.error) return children;

    // the errorInAppLevel prop is used to differentiate the origin of error.
    // if the error occurs from the minor components (ErrorBoundary has to wrap that component)
    // Eg: BreadCrumbs, Reviews and MountainFinder
    // We shallow that error returning null
    // It doesn't make sense to crash the whole app if only the minor component breaks

    // Meanwhile, errorInAppLevel is only used to wrap around the whole app @see /src/App.js
    return errorInAppLevel ? <Error404 /> : null;
  }
}

export default connect(mapStateToProps)(ErrorBoundary);



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary/ErrorBoundary.jsx